import { fileService } from './fileService';
import { FileItem } from '../types/FileItem';

export const fileActions = {
  async loadFiles(prefix: string): Promise<FileItem[]> {
    return await fileService.list(prefix);
  },

  async deleteFile(item: FileItem): Promise<boolean> {
    const confirmDelete = window.confirm(`Delete ${item.name}?`);
    if (!confirmDelete) return false;

    const success = await fileService.delete(item.path);
    if (success) {
      alert(`${item.name} deleted successfully`);
      return true;
    }
    alert(`Failed to delete ${item.name}`);
    return false;
  },

  async downloadFile(item: FileItem): Promise<void> {
    await fileService.download(item.path, item.name);
  },

  async downloadFolder(item: FileItem) {
    await fileService.downloadFolderAsZip(item.path, item.name);
  },

  async uploadFile(file: File, folderPath: string = ""): Promise<void> {
    await fileService.uploadPresigned(file, folderPath);
  },

  async renameItem(item: FileItem, newName: string): Promise<boolean> {
    if (newName !== item.name) {
      const result = await fileService.renameItem(item, newName);
      return result; // boolean from API
    }

    // Name didn't change, so return false
    return false;
  }
};
